/**
 * Clear cart after successful checkout redirect
 * Runs on thank you page (dyakuyemo) after payment or COD order
 */

document.addEventListener('DOMContentLoaded', function() {
  console.log('🔍 Clear cart script loaded');
  
  // Check if we're on a page with orderId parameter (thank you page)
  const urlParams = new URLSearchParams(window.location.search);
  const orderId = urlParams.get('orderId');
  const orderName = urlParams.get('orderName');
  const deliveryCity = urlParams.get('deliveryCity');
  const deliveryWarehouse = urlParams.get('deliveryWarehouse');
  const deliveryPostcode = urlParams.get('deliveryPostcode');
  const deliveryRegion = urlParams.get('deliveryRegion');
  const deliveryDistrict = urlParams.get('deliveryDistrict');
  const deliveryAddress = urlParams.get('deliveryAddress');
  const deliveryType = urlParams.get('deliveryType');
  
  console.log('📋 URL params:', { orderId, orderName, deliveryType });
  
  if (orderId) {
    console.log('🛒 Thank you page detected, clearing cart for order:', orderId);
    
    // Check if we're on the dyakuyemo page
    if (window.location.pathname.includes('dyakuyemo')) {
      // Hide the default page content
      const mainPageContent = document.querySelector('.main-page-title');
      if (mainPageContent) {
        const pageWidth = mainPageContent.closest('.page-width');
        if (pageWidth) {
          pageWidth.style.display = 'none';
        }
      }
      
      // Create and display order success info
      const successDiv = document.createElement('div');
      successDiv.id = 'order-success-info';
      successDiv.style.cssText = 'margin: 2rem auto; padding: 2rem; background: #f9fafb; border-radius: 0.5rem; max-width: 600px;';
      
      successDiv.innerHTML = `
        <div style="text-align: center; margin-bottom: 1.5rem;">
          <div style="display: inline-flex; align-items: center; justify-content: center; width: 4rem; height: 4rem; background: #d1fae5; border-radius: 50%; margin-bottom: 1rem;">
            <svg style="width: 2rem; height: 2rem; color: #059669;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <h2 style="font-size: 2.5rem; font-weight: bold; color: #111827; margin-bottom: 0.5rem;">Замовлення прийнято!</h2>
          <p id="order-name-display" style="font-size: 2rem; font-weight: 600; color: #059669; margin-bottom: 0.5rem;"></p>
        </div>
        
        <div id="delivery-address-display" style="padding: 1rem; background: white; border-radius: 0.5rem; margin-bottom: 1rem; text-align: left;">
          <h3 style="font-size: 2rem; font-weight: 600; color: #374151; margin-bottom: 0.5rem;">Адреса доставки:</h3>
          <p id="address-text" style="font-size: 2rem; color: #40744fff; line-height: 1.6;"></p>
        </div>
        
        <p style="color: #6b7280; margin-top: 1rem; text-align: center; font-size: 2rem; font-weight: 500;">Дякуємо! Якщо все добре, будемо відправляти.</p>
        
        <div style="text-align: center;">
          <a href="/" style="display: inline-block; margin-top: 1.5rem; padding: 0.75rem 1.5rem; background: #059669; color: white; text-decoration: none; border-radius: 0.375rem; font-weight: 500; font-size: 1.25rem;">
            Повернутися до магазину
          </a>
        </div>
      `;
      
      // Insert after the main section or at the beginning of main content
      const mainContent = document.querySelector('main') || document.querySelector('#MainContent');
      if (mainContent) {
        mainContent.insertBefore(successDiv, mainContent.firstChild);
      }
      
      // Fill in the order data
      const orderNameDisplay = document.getElementById('order-name-display');
      const addressText = document.getElementById('address-text');
      const deliveryAddressDisplay = document.getElementById('delivery-address-display');
      
      if (orderName && orderNameDisplay) {
        orderNameDisplay.textContent = 'Номер вашого замовлення: ' + decodeURIComponent(orderName);
      }
      
      // Format and display delivery address
      if (deliveryType === 'novaposhta' && deliveryCity && deliveryWarehouse) {
        const city = decodeURIComponent(deliveryCity).split(' (')[0];
        const warehouse = decodeURIComponent(deliveryWarehouse);
        addressText.innerHTML = '<strong>Нова Пошта</strong><br>' + city + ', ' + warehouse;
        console.log('✅ Nova Poshta address displayed');
      } else if (deliveryType === 'ukrposhta' && deliveryPostcode) {
        const postcode = decodeURIComponent(deliveryPostcode);
        const region = deliveryRegion ? decodeURIComponent(deliveryRegion) : '';
        const district = deliveryDistrict ? decodeURIComponent(deliveryDistrict) : '';
        const city = deliveryCity ? decodeURIComponent(deliveryCity) : '';
        const address = deliveryAddress ? decodeURIComponent(deliveryAddress) : '';
        
        let fullAddress = '<strong>Укрпошта</strong><br>' + [postcode, region, district, city].filter(Boolean).join(', ');
        if (address) {
          fullAddress += '<br>' + address;
        }
        addressText.innerHTML = fullAddress;
        console.log('✅ Ukrposhta address displayed');
      } else if (deliveryAddressDisplay) {
        // Hide address section if no delivery info
        deliveryAddressDisplay.style.display = 'none';
        console.log('⚠️ No delivery info to display');
      }
    }
    
    // Clear the cart using Shopify's Ajax API
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(function(response) {
      if (response.ok) {
        console.log('✅ Cart cleared successfully after checkout');
        
        // Update cart state for theme components
        return fetch('/cart.js');
      } else {
        console.warn('⚠️ Cart clear returned status:', response.status);
        return null;
      }
    })
    .then(function(response) {
      if (response) {
        return response.json();
      }
      return null;
    })
    .then(function(cart) {
      if (cart) {
        // Dispatch custom event for cart drawer/notification
        document.dispatchEvent(new CustomEvent('cart:updated', { 
          detail: { cart: cart } 
        }));
        
        // Update cart count badge if present
        const cartCountElements = document.querySelectorAll('.cart-count-bubble, [data-cart-count]');
        cartCountElements.forEach(function(element) {
          element.textContent = '0';
          element.classList.add('hidden');
        });
      }
    })
    .catch(function(error) {
      console.error('⚠️ Error clearing cart:', error);
    });
  } else {
    console.log('ℹ️ No orderId parameter found, showing default page content');
  }
});
